import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import imgClose from '../../images/common/i_close_btn.svg'



const ContentWrap = styled.div`
    display: block;
`;

const InnerBox = styled.div`
    display: flex; 
    flex-direction: column; 
    align-items: flex-start; 
    justify-content: center; 
    padding: 1.6rem; 
    
    & > strong {
        display: block;
        width: 100%;
        padding-bottom: 1rem;
        border-bottom: 1px solid #E2E6EC;
        font-size: 1.6rem; 
        color: #10141A; 
    }
    &  .close-btn {
        position: absolute; 
        z-index: 1;
        top: var(--sp-16); 
        right: var(--sp-16);
        width: var(--sp-24); 
        height: var(--sp-24);
        background: url(${imgClose}) no-repeat center;
        background-size: 100%;
        z-index: 10;
    }
`;

const ContentBox = styled.div`
    display: block;
    margin-top: 1rem;
    width: 100%;

    & p + ul {margin-top: 1rem;}

    .table {
        overflow-x: auto;
    }

    & p {
        font-size: var(--mo-fz-smd);
        color: var(--color-main-gray);
    }

    & h3 {
        font-size: var(--mo-fz-lg);
        font-weight: var(--fz-weight-700);
        margin-top: 2rem;
        margin-bottom: 1rem;
        color: var(--color-main-black);
    }
    
    & b {
        color: var(--color-main-5);
    }
    
    & strong {
        font-weight: var(--fz-weight-700);
        color: var(--color-main-black);
    }
    
    & ul, & ol {
        margin-left: 2rem;
        margin-bottom: 1rem;
    }
    
    & li {
        margin-bottom: 0.5rem;
        line-height: 1.6;
    }
    
    & .table-wrapper {
        width: 100%;
        overflow-x: auto;
        margin: 1.6rem 0;
        -webkit-overflow-scrolling: touch;
        
        &::-webkit-scrollbar {
            height: 20px;
        }
        
        &::-webkit-scrollbar-track {
            background: transparent; border-radius: var(--radius-12);
        }
        
        &::-webkit-scrollbar-thumb {
            background: #E2E6EC; border-radius: var(--radius-12);  border: 7px solid #fff;
        }
        
        &::-webkit-scrollbar-thumb:hover {
            background: var(--color-main-gray-5);
        }
    }

     & table {
        width: 100%;
        border-collapse: collapse;
        font-size: var(--mo-fz-smd);
        background-color: var(--color-white);
        min-width: 600px; 
        table-layout: fixed; 
    }
    
    & thead {
        background-color: var(--color-main-gray-45);
    }
    
    & th {
        padding: 1.2rem 0.8rem;
        text-align: center;
        font-weight: var(--fz-weight-700);
        color: var(--color-main-black);
        border: 1px solid var(--color-main-gray-50);
        vertical-align: middle;
        white-space: nowrap; /* 헤더 텍스트 줄바꿈 방지 */
    }
    
    & td {
        padding: var(--sp-12);
        color: var(--color-main-gray);
        border: 1px solid var(--color-main-gray-50);
        line-height: 1.6;
        vertical-align: middle;
        text-align: center;
    }
    
`;

const TitleBox = styled.strong`
    font-size: var(--mo-fz-lg);
    color: var(--color-main-gray);
    font-weight: var(--fz-weight-700);
`;




const AgreeConditionsBox = ({title ,onClose, children}) => {

    const processedHtml = useMemo(() => {
        console.log('🔄 children changed:', children); // 이 로그가 치환된 값으로 찍히는지 확인
        if (!children) return '';
        const result = children.replace(/<table([\s\S]*?)<\/table>/gi,
            '<div class="table-wrapper"><table$1</table></div>');
        console.log('🔄 processed:', result);
        return result;
    }, [children]);

    return (
        <ContentWrap>
            <InnerBox>

                <TitleBox>{title ? title : "약관 동의" }</TitleBox>
                {/* <ContentBox> */}
                    {/* {children} */}
                        <ContentBox
                            dangerouslySetInnerHTML={{ __html: processedHtml }}
                        />

                <button className='close-btn' onClick={onClose}>
                    <span className='blind'>팝업 닫기</span>
                </button>
            </InnerBox>
        </ContentWrap>
    );
};

export default AgreeConditionsBox;
